const getAuthRedirectUrl = () => `${window.location.origin}/auth`;

export default getAuthRedirectUrl;
